import * as types from './types';

export default {
    allowAccess({ commit }, data) {
        commit(types.LOGIN_SUCCESS, data);
    }
};